module.exports = __webpack_public_path__ + "a768e7de/img/arrow-export-icon.a3345173.svg";